export interface MenuItemTypes {
  key: string;
  label: string;
  isTitle?: boolean;
  icon?: string;
  url?: string;
  badge?: {
    variant: string;
    text: string;
  };
  parentKey?: string;
  target?: string;
  children?: MenuItemTypes[];
}

const HORIZONTAL_MENU_ITEMS: MenuItemTypes[] = [
  {
    key: "dashboard",
    icon: "home",
    label: "Dashboard",
    isTitle: true,
    children: [
      {
        key: "ds-dashboard",
        label: "Início",
        url: "/dashboard",
        parentKey: "dashboard",
      },
    ],
  },
  {
    key: "apps1",
    icon: "grid",
    label: "Fazendas",
    isTitle: true,
    children: [
      {
        key: "fazenda-listagem",
        label: "Listagem",
        isTitle: false,
        icon: "list",
        url: "/fazendas",
        parentKey: "apps",
      },
      {
        key: "fazenda-listagem",
        label: "Importações",
        isTitle: false,
        icon: "list",
        url: "/fazendas-importacoes",
        parentKey: "apps",
      },
    ],
  },
  {
    key: "apps2",
    icon: "grid",
    label: "Protocolos",
    isTitle: true,
    children: [
      {
        key: "protocolos-listagem",
        label: "Listagem",
        isTitle: false,
        icon: "list",
        url: "/protocolos",
        parentKey: "apps2",
      },
    ],
  },
  {
    key: "apps3",
    icon: "database",
    label: "Relatórios",
    isTitle: true,
    children: [
      {
        key: "relatorios-gerar",
        label: "Gerar Relatórios",
        isTitle: false,
        icon: "file-text",
        url: "/relatorios",
        parentKey: "apps3",
      },
    ],
  },
  {
    key: "apps",
    icon: "grid",
    label: "Cadastros",
    isTitle: true,
    children: [
      {
        key: "cadastro-classes",
        label: "Classes",
        isTitle: false,
        icon: "layers",
        url: "/classes",
        parentKey: "apps",
      },
      {
        key: "cadastro-tipo-corte",
        label: "Tipo de atividade",
        isTitle: false,
        icon: "layers",
        url: "/tipo-corte",
        parentKey: "apps",
      },
      {
        key: "cadastro-produto",
        label: "Produtos",
        isTitle: false,
        icon: "shopping-cart",
        url: "/produtos",
        parentKey: "apps",
      },
      {
        key: "cadastro-manejo",
        label: "Manejos",
        isTitle: false,
        icon: "calendar",
        url: "/manejos",
        parentKey: "apps",
      },
      {
        key: "cadastro-animal",
        label: "Animais",
        isTitle: false,
        icon: "github",
        url: "/animais",
        parentKey: "apps",
      },
      {
        key: "cadastro-documentos",
        label: "Documentos",
        isTitle: false,
        icon: "list",
        url: "/documentos",
        parentKey: "apps",
      },
      {
        key: "cadastro-territorios",
        label: "Territórios",
        isTitle: false,
        icon: "list",
        url: "/territorios",
        parentKey: "apps",
      },
      {
        key: "cadastro-usuarios",
        label: "Usuários",
        isTitle: false,
        icon: "users",
        url: "/usuarios",
        parentKey: "apps",
      },
      {
        key: "cadastro-cargos",
        label: "Cargos",
        isTitle: false,
        icon: "layers",
        url: "/cargos",
        parentKey: "apps",
      },
    ],
  },
];

export { HORIZONTAL_MENU_ITEMS };
